export default "__VITE_ASSET__hr86B$nu__"